import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges Tailwind CSS classes using clsx and tailwind-merge.
 * This ensures that conflicting classes are merged correctly (e.g., p-4 p-8 -> p-8).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
